import { render, staticRenderFns } from "./RegisterComponent.vue?vue&type=template&id=d6153368&scoped=true"
import script from "./RegisterComponent.vue?vue&type=script&lang=js"
export * from "./RegisterComponent.vue?vue&type=script&lang=js"
import style0 from "./RegisterComponent.vue?vue&type=style&index=0&id=d6153368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6153368",
  null
  
)

export default component.exports